/**
 * 計助ダッシュボード: localStorage への JSON 保存（容量・プライベートモード等は握りつぶす）
 */

export function safeLocalStorageSetJson(key: string, value: unknown): void {
  try {
    localStorage.setItem(key, JSON.stringify(value));
  } catch {
    // ignore
  }
}
